import { render } from "./TrackPlayer.vue?vue&type=template&id=334e9a42&scoped=true"
import script from "./TrackPlayer.vue?vue&type=script&lang=js"
export * from "./TrackPlayer.vue?vue&type=script&lang=js"

import "./TrackPlayer.vue?vue&type=style&index=0&id=334e9a42&scoped=true&lang=scss"

import exportComponent from "/Users/macbook/Mubasher/Mubasher/Projects/Live/bling-rock/Project-Live/soundcode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-334e9a42"]])

export default __exports__